import { ReactNode, useContext } from 'react';
import { TabsOption } from 'global';
import { PageContainer } from 'components/shared/Page/PageContainer';
import DealerManagementList from 'pages/LenderPortal/DealerMgmt/DealerList';
import { DealerManagementTabs } from 'modules/lenderDealerManagement/types';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { CardBackground } from 'components/CardBackground/CardBackground';
import { BroadcastsTable } from 'modules/broadcasts';
import { CommonDataContext } from 'contexts/CommonDataContext';

export const DealerManagementPage = () => {
  const { isSuperAdminOrSingleAccount } = useContext(CommonDataContext);

  const tabs: TabsOption<DealerManagementTabs>[] = [
    {
      label: 'Dealer Management',
      value: DealerManagementTabs.DealerManagement,
      component: <DealerManagementList />,
      urlAnchor: `#${DealerManagementTabs.DealerManagement}`,
      isVisible: true,
    },
    {
      label: 'Broadcasts',
      value: DealerManagementTabs.Broadcasts,
      component: <BroadcastsTable />,
      urlAnchor: `#${DealerManagementTabs.Broadcasts}`,
      isVisible: isSuperAdminOrSingleAccount,
    },
  ];

  return (
    <PageContainer>
      <TabsContainer<DealerManagementTabs>
        tabs={tabs}
        TabsLabelWrapper={CardBackground}
        tabsWrapperProps={{ mb: 1 }}
        isSyncWithAnchor
      />
    </PageContainer>
  );
};
